import React, { useState } from "react"
// Ajuste os imports abaixo conforme a estrutura do seu projeto
import SideBarLayout from "../../../layout/side-bar-layout"
import { TITLE_DESIGN_SYSTEM_PAGE } from "../../../../utils/constants"
import { Box, Paper, Typography, Stack } from "@mui/material"
import CodeViewer from "../../../components/CodeViewer/code-viewer"

// IMPORTANTE: Verifique se este caminho está correto para o seu arquivo DuplicarModal
import DuplicarModal from "src/v2/pages/MotorCadastros/components/DuplicarModal/duplicar-modal"

// Botão para abrir o modal (usando o mesmo que você usa no sistema)
import ButtonWithIcon from "src/v2/components/Button/Button"

const ModalDuplicarDesignSystemPage = () => {
    const [openDuplicar, setOpenDuplicar] = useState(false)
    const TITLE_PAGE = `${TITLE_DESIGN_SYSTEM_PAGE} | Modal Duplicar`

    // String do código para exibição (apenas visual)
    const codeBasicUsage = `
    // 1. Definição dos estados e handler
    const [open, setOpen] = useState(false);
    const [linhaSelecionada, setLinhaSelecionada] = useState({ id: 1, cetip: '123' });

    const handleConfirmarDuplicacao = (dadosDuplicacao) => {
        // 'dadosDuplicacao' contém o objeto original + os novos campos
        const { original, novoCetip, novaVersao } = dadosDuplicacao;

        setOpen(false);
    };

    // 2. Renderização do Componente
    return (
        <DuplicarModal 
            open={open} 
            onClose={() => setOpen(false)} 
            rowOriginal={linhaSelecionada} 
            onConfirm={handleConfirmarDuplicacao} 
        />
    );
    `

    const codePropsTable = `
    // Interface das Props
    type DuplicarModalProps = {
        open: boolean;
        onClose: () => void;
        
        /**
         * Objeto da linha que será duplicada. 
         * É usado para preencher o contexto da ação.
         */
        rowOriginal: object; 

        /**
         * Função de callback chamada ao clicar em "Cadastrar".
         * Retorna um objeto contendo os dados originais e os novos inputs.
         */
        onConfirm: (payload: { 
            original: object, 
            novoCetip: string, 
            novaVersao: string 
        }) => void;
    }
    `

    return (
        <SideBarLayout
            header
            title={TITLE_PAGE}
            headerTitle={TITLE_PAGE}
        >
            <Box sx={{ mt: -2 }}>
                <Stack spacing={3}>

                    {/* CABEÇALHO DA DOCUMENTAÇÃO */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h4" gutterBottom color="common.white">
                                Modal Duplicar
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Modal utilizado para duplicar registros. Ele solicita a nova CETIP e a nova Versão.
                            </Typography>
                        </Box>
                    </Paper>

                    {/* ÁREA DE TESTE (DEMONSTRAÇÃO) */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Demonstração Interativa
                            </Typography>
                            
                            <Typography variant="body2" color="text.secondary" paragraph>
                                Clique no botão abaixo para testar o modal.
                            </Typography>

                            <ButtonWithIcon
                                onClick={() => setOpenDuplicar(true)}
                                label="Testar Duplicação"
                                primary
                            >
                                ABRIR MODAL
                            </ButtonWithIcon>

                            <DuplicarModal
                                open={openDuplicar}
                                onClose={() => setOpenDuplicar(false)}
                                onConfirm={() => {
                                    setOpenDuplicar(false)
                                }}
                                rowOriginal={{ id: 99, nome: "Dado Original Mockado" }}
                            />
                        </Box>
                    </Paper>

                    {/* EXIBIÇÃO DO CÓDIGO */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Como usar
                            </Typography>
                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeBasicUsage} language="jsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                    {/* PROPRIEDADES */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Propriedades (Props)
                            </Typography>
                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codePropsTable} language="tsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                </Stack>
            </Box>
        </SideBarLayout>
    )
}

export default ModalDuplicarDesignSystemPage